export const HERO_MODULE_PORTAL = 'hero-module--portal';

// NOTE: for local VDI development this should be turn to false else should always be true
export const AKAMAI_BOT_FLAG = true;

export const X_CORRELATION_APP = 'Portal';
